var gaHitCallbackHandler;
var $noTransformRootMenuItem = null;
var $layout = {
    isOldIE: false,
	elements: {
        body: null,
        contentWrapper: null,
        menu: null,
        menuWidget: null, //kendo or pushmenu
        menuTrigger: null, //Dont use directly
        getMenuTrigger: function () {
            if (this.menuTrigger === null)
                this.menuTrigger = $("#trigger");

            return this.menuTrigger;
        },
        getBody: function () {
            if (this.body === null)
                this.body = $(document.body);  

            return this.body;
        }
	}, 
    isMobile: function(){
        return $(window).width() <= 990;
    },
    menuType: null, 
    isAjaxMenu: false
};

//#region PAGE LOAD METHODS

function loadRecentPages() {
    var list = $("#recentpages-list");
    list.empty();
     
    $.ajax({
        dataType: "json",
        url: "/RestApi/layout/menu/recent",
        success: function (data) {
            var template = kendo.template(getRecentPagesTemplate());
            var recentItemsHtml = template(data);

            list.append(recentItemsHtml);

            sendGATagTrackingEvent("Main Menu", "Recent Pages", "Open");
        }
    });
} 

$(function () {
    try {
        cachePageElements();

        cleanupLocalStorage();
        wireUpPods(); 
        lookFor2fa();
        lookForNotificationDots();
        styleFixes();
        findAndFixTables();

        decideMenuStyle();

        if (!$layout.elements.getBody().data("dynamicmenu")) {
            createMenu();
        } else {
            $layout.elements.menu = $("#rootmenu");
            $layout.isAjaxMenu = true;

            $layout.elements.getMenuTrigger().on("click", function(e){
                e.stopPropagation();
                e.preventDefault();

                //Send GA Tracking
                sendGATagTrackingEvent('Main Menu', 'Open');

                initalizeAjaxMenu();
            });
        }

        //Collapse all pods if we're on mobile size
        if ($layout.isMobile()) {
            wireUpMobile();
        }

        wireUpMiscGATracking();
        wireUpGADocumentTracking();

        setupRaygun();
    }catch (e){
        sendRaygunError(e);
    }
});
//#endregion

function sendRaygunError(e) {
    if (typeof Raygun != 'undefined') {
        Raygun.send(e);
    }

    if (typeof gtag != "undefined") {
        gtag('event', 'exception', {
            'description': e,
            'fatal': false
        });
    }
}

function cleanupLocalStorage() {
    var cleanCount = 0;

    var keys = getAllLocalStorageKeys();
    for (var i = 0; i < keys.length; i++) {
        if (keys[i].includes("profile-") || keys[i].includes("undefined")) {
            console.log("Cleared old menu local storage item", keys[i]);
            localStorage.removeItem(keys[i]);
            cleanCount++;
        }
    }

    if (cleanCount > 0) {
        console.log("Cleaned up " + cleanCount + " local storage entries");
    }
}

var _2faKey = "2fa-dismissed";
function lookFor2fa() {
    if (!localStorage.getItem(_2faKey) || $("body").hasClass("sfPageEditor")) {
        var content = '<div class="pod-wrapper">\
                            <div class="pod-content clearfix">\
                                <div class="header clearfix">\
                                    <i class="fab fa-google pull-left"></i>\
                                    <i class="fas fa-times pull-right" onclick="dismiss2fa(this); return false;"></i>\
                                </div>\
                                <p>\
                                    We recommend you enable 2-Step Verification for your medportal account to keep it secure. 2-Step Verification can help keep bad guys out, even if they have your password.\
                                </p>\
                                <a href="/public/help/general/log-in/enable-2-factor-authentication" class="btn btn-link pull-right">Learn how</a>\
                            </div>\
                        </div>';
        $("#two-factor-prompt").html(content);
    }
}

var _notificationDotStringFormat = "dot-{0}-{1}"
function lookForNotificationDots() {
    var dots = $("[data-notification-key]");

    for (var i = 0; i < dots.length; i++) {
        var dot = dots[i];
        var key = $(dot).data("notification-key");
        var userId = $medportal.User.IsAnonymous ? $("body").data("sessionid") : $medportal.User.ID;
        var cacheKey = _notificationDotStringFormat.replace("{0}", userId).replace("{1}", key);

        if (!localStorage.getItem(cacheKey)) {
            //Cache for this item doesn't exist

            //Add the class
            $(dot).addClass("notification-dot");

            //Wire up the click
            $(dot).on("click", function () {
                var dateAdded = new Date().toString();
                localStorage.setItem(cacheKey, dateAdded);
                console.log("Added " + cacheKey + " at " + dateAdded);
            });
        } else {
            //Cache exists
            console.log("Already clicked " + cacheKey);
        }
    }
}

function dismiss2fa(element) {
    $("#two-factor-prompt").remove();

    localStorage.setItem(_2faKey, true);
}


function isInDesignMode() {
    var theBody = $("body");
    var path = window.location.pathname;
    return theBody.hasClass("sfPageEditor") || path.includes("Sitefinity") || path.includes("Action");
}

function setupRaygun() {
    //Setup raygun
    if (typeof rg4js != "undefined") {
        if (window.location.host == "www.medportal.ca") {
            var sfVersion = $("meta[name='Generator']").attr("content").replace("Sitefinity ", "").replace(" PU", "");
            //Main Key: SHFakWdEF//J3X1psostYw==
            //JS Key: BKevKXFSKjG/lu7rsp8IXw== 
            rg4js('apiKey', 'SHFakWdEF//J3X1psostYw==');
            rg4js('attach', true);
            rg4js('enablePulse', true);
            rg4js('enableCrashReporting', true);
            rg4js('logContentsOfXhrCalls', true);
            
            rg4js('setVersion', sfVersion);
            rg4js('options', {
                ignore3rdPartyErrors: true,
                pulseCustomLoadTimeEnabled: true
            });
            if ($medportal) {
                rg4js('withCustomData', $medportal);
                rg4js('setUser', {
                    identifier: $medportal.User.UserName,
                    isAnonymous: $medportal.User.IsAnonymous,
                    email: $medportal.User.UserName,
                    fullName: $medportal.User.UserName,
                    uuid: $medportal.User.ID
                });
            } 
        }
    }
}

var cachePrefix = "menuhtml";
function getMenuCacheKey() {
    var sessionId = $("body").data("sessionid");
    if ($medportal.User.ID)
        return cachePrefix + "-" + $medportal.User.ID + "-" + sessionId + "-" + $medportal.CacheKey;
    else
        return cachePrefix + "-" + sessionId + "-" + $medportal.CacheKey;
}

function clearMenuCache() {
    localStorage.removeItem(getMenuCacheKey());
}

function initalizeAjaxMenu() {
    if (!$layout.elements.menu.data("initalized")) {
        
        var menuData = "";
        var hasCache = false;
        
        var cacheKey = getMenuCacheKey();

        if (Modernizr.localstorage) {
            //Check for cached data
            var menuhtml = localStorage.getItem(cacheKey);
            if(menuhtml !== null){
                menuData = menuhtml;
                hasCache = true;
            }
        }

        if (hasCache === false) {
            $.ajax({
                beforeSend: function () {
                    $("#trigger i").removeClass("fa-bars").addClass("fa-spinner fa-pulse");
                },
                url: "/RestApi/layout/menu/structure/html",
                contentType: "text/html"
            }).done(function (data) {
                $("#trigger i").removeClass("fa-spinner fa-pulse").addClass("fa-bars");

                setMenuData(data);

                //Save results to local storage if it exists
                if (Modernizr.localstorage) {
                    //Find the PREVIOUS cache item and kill it

                    var keys = getAllLocalStorageKeys();
                    for (var i = 0; i < keys.length; i++) {
                        if (keys[i].includes(cachePrefix)) {
                            console.log("Cleared old menu local storage item", keys[i]);
                            localStorage.removeItem(keys[i]);
                            break;
                        }
                    }

                    try {
                        localStorage.setItem(cacheKey, data);
                        console.log("Created new menu local storage item", cacheKey);
                    } catch(e){
                        console.log("Error setting local storage", e);
                        //Ok, don't store it, clear it likely due to:
                        //Message: Failed to execute 'setItem' on 'Storage': Setting the value of 'menuhtml-2018-08-29-5f06ea06-4cd1-4fc4-9a94-3a3565e52f0b-vhfmhrxoenqbnwi3fmihmgow' exceeded the quota.
                    }
                }
            });

        } else {
            console.log("Using cached menu key: " + cacheKey);
            setMenuData(menuData);
        }

    }

    openMainMenu();

}


function getAllLocalStorageKeys() {
    return Object.keys(localStorage);
}

function getAllLocalStorageItems() {

    var values = [];
    var keys = getAllLocalStorageKeys();
    var i = keys.length;

    while (i--) {
        values.push(localStorage.getItem(keys[i]));
    }

    return values;
}

function setMenuData(menuData) {
    $layout.elements.menu.html(menuData);
    createMenu();
    $layout.elements.menu.data("initalized", true);


    //Wire up GA
    $("#rootmenu a").on("click", function (e) {
        if ($(this).next().length === 0) {
            var link = $(this).attr("href");
            var name = $(this).data("name");

            //No children, log this click
            sendGATagTrackingEvent('Main Menu', 'Navigate to Page', name, link);
        }
    });

}

function decideMenuStyle() {
    if (Modernizr.csstransforms3d === true && !$("html").hasClass("k-ie")) {
        //WAIT WAIT...check for IE...it borks csstransforms
        $layout.menuType = "Fancy";
    } else {
        //Load the IE7 version of the menu
        $layout.menuType = "Ghetto";

        //Allows Debugging, fakes the lack of feature
        $("html").removeClass("csstransforms3d").addClass("no-csstransforms3d");
    }
}

function createMenu() {
    if ($layout.menuType === "Fancy") {
        //WAIT WAIT...check for IE...it borks csstransforms
        wirePushMenu();
    } else {
        //Load the IE7 version of the menu
        wirePanelbarMenu();
    }
}

function wirePushMenu() {
    try {
        if (!$medportal.IsDesignMode) {
            var menu = document.getElementById('mp-menu');
            var trigger = $layout.elements.getMenuTrigger().get(0);

            var shouldOpenAfterInit = $layout.isAjaxMenu;

            if (typeof mlPushMenu != "undefined") {
                $layout.elements.menuWidget = new mlPushMenu(menu, trigger, {
                    type: 'cover'
                }, shouldOpenAfterInit);
            } else {
                alert("Error Loading Menu, Please contact Support");
            }
        }
    } catch (e) {
        sendRaygunError(e);
    }
}

function wirePanelbarMenu() {

    //Modify the menu markup
    var root = $("#rootmenu");

    root.find(".mp-level").each(function () {
        var list = $(this).find("> ul:first");
        $(this).after(list);
    });

    if ($noTransformRootMenuItem === null) {
        $noTransformRootMenuItem = $("#rootmenu");

        //Fix menu first
        $layout.elements.menuWidget = $noTransformRootMenuItem.kendoPanelBar();
    }

    $layout.elements.getMenuTrigger().on("click", function (e) {
        e.preventDefault();

        triggerPanelBarMenu();
    });
}

function closeMainMenu(){
    if ($layout.menuType === "Ghetto") {
        //$layout.elements.getMenuTrigger().click();
        var pusher = $("#mp-pusher");
        pusher.removeClass("mp-pushed");
    } else {
        if ($layout.elements.menuWidget) {
            $layout.elements.menuWidget._resetMenu();
        }
    }
}

function openMainMenu() {
    if ($layout.menuType === "Ghetto") {
        triggerPanelBarMenu();
    }
}

function triggerPanelBarMenu() {
    var pusher = $("#mp-pusher");
    pusher.addClass("mp-pushed");

    if (!pusher.hasClass("mp-pushed")) {
        pusher.css("zoom", 1);
    }
    else {
        pusher.removeAttr("style");
    }
}

/// Toggles visiblity on an element, this should be common to all expandable elements
function onToggleElement(element, selector, collapseNext, analyticsLabel) {
    try {
        var target = $(element);
        var podTitleText = "";
        var isCollapsed = null;

        if (target.attr("data-root")) {
            target.data("root").toggleClass("collapsed");

            //Get title
            var podTitle = target.find(".titletext");
            if (podTitle) {
                podTitleText = podTitle.text();
                isCollapsed = target.hasClass("collapsed");
            }
        } else {
            if (!collapseNext) {
                //Selector collapse
                var root = target.closest(selector);
                target.data("root", root);
                if (!root.hasClass("show-all")) {
                    root.toggleClass("collapsed");

                    //Get title
                    var podTitle = root.find(".titletext");
                    if (podTitle) {
                        podTitleText = podTitle.text();
                        isCollapsed = root.hasClass("collapsed");
                    }
                }
            } else {
                //Hide next element...from the "selector"
                var parent = target.closest(selector);
                if (parent !== null) {
                    var nextElement = parent.next();
                    if (nextElement.length > 0) {
                        parent.toggleClass("collapsed");
                        isCollapsed = parent.hasClass("collapsed");
                        nextElement.addClass("managed-by-control");
                        nextElement.toggle();
                    }
                }
            }
        }

        if (selector === ".pod-wrapper") {
            sendGATagTrackingEvent('Pods', isCollapsed ? "Collapse" : "Expand", podTitleText);
        }
        else if (selector === ".contact-wrapper") {
            sendGATagTrackingEvent('Contact Card', isCollapsed ? "Collapse" : "Expand", analyticsLabel);
        }
        else if (selector === ".sfitem.resource") {
            sendGATagTrackingEvent('Resource', isCollapsed ? "Collapse" : "Expand", analyticsLabel);
        }
    } catch (e) {
        sendRaygunError(e);
    }
}

function getNumberPostfix(index) {
    var postfix = "";
    var integer = parseInt(index);

    switch (integer % 100) {
        case 11:
        case 12:
        case 13:
            postfix = "th";
            break;
    }

    switch (integer % 10) {
        case 1:
            postfix = "st";
            break;
        case 2:
            postfix = "nd";
            break;
        case 3:
            postfix = "rd";
            break;
        default:
            postfix = "th";
    }

    return integer + postfix;
}

function wireUpMobile() {
    try {
        if ($(window).width() < 760) {
            collapseAllPods();
        }

        //Get reference
        var dropZone;

        //Is there a single page title?
        var pageTitle = $(".page-title");

        if (pageTitle.length > 0) {
            dropZone = pageTitle.first();
        } else {
            //Get the breadcrumbs
            dropZone = $(".breadcrumb-layout-wapper")
        }


        //Set inital defaults
        var menuChildren = [];

        //Mobile subnav menu
        $(".medportal-nav a:not(.ignore-for-mobile-menu)").each(function (nav) {
            var node = $(this);
            var text = node.text();
            var url = node.attr("href");

            var newItem = {
                "url": url,
                "text": text
            };

            var canAdd = true;
            for (var i = 0; i < menuChildren.length; i++) {
                if (menuChildren[i].url === url) {
                    canAdd = false; //Already there
                }
            }

            if (canAdd) {
                menuChildren.push(newItem);
            }
        });

        if (menuChildren.length > 0) {
            //Add a default node because the first is unselectable if it's selected (science)
            var emptyItem = {
                "url": "#",
                "text": "Navigate to..."
            };

            menuChildren.unshift(emptyItem);
            console.log(menuChildren); 
            /*jshint multistr: true */
            var templateString = "<div class='row margin-bottom-20 hidden-md hidden-lg'>\
                                <div class='col-xs-12'>\
                                    <label>Navigation</label>\
                                    <select id='mobile-dropdown-nav' class='form-control input-lg'>\
                                        # for (var i = 0; i < data.length; i++) { #\
                                            <option value='#= data[i].url #'>#= data[i].text #</option>\
                                        # } #\
                                    </select>\
                                </div>\
                            </div>";

            var template = kendo.template(templateString);
            var html = template(menuChildren);

            dropZone.after(html);

            var nav = $("#mobile-dropdown-nav");
            //Disable the first item
            nav.find("option:first-child").attr("disabled", "disabled");

            //Wire up click
            nav.change(function () {
                if ($(this).val() != '') {
                    window.location.href = $(this).val();
                }
            });
        }
    } catch (e) {
        sendRaygunError(e);
    }
}

function collapseAllPods() {
    try {
        //Collapse Pods
        $(".pod-wrapper:not(.notcollapsable):gt(0)", "#content-wrapper").each(function () {
            if ($(this).find(".expand-collapse-icon").length > 0) {
                $(this).addClass("collapsed");
            }
        });
    } catch (e) {
        sendRaygunError(e);
    }
}

function toggleAllPods() {
    try {
        //Collapse Pods
        $(".pod-wrapper", "#content-wrapper").toggleClass("collapsed");
    } catch (e) {
        sendRaygunError(e);
    }
}

function onMobileBreadcrumbMenuChange() {
    try {
        window.location = $layout.mobileDropDown.find("option:selected").val();
    }
    catch (e) {
        sendRaygunError(e);
    }
}


function wireUpGADocumentTracking() {
    if (!$medportal.IsDesignMode) {
        var filetypes = /\.(zip|exe|dmg|pdf|doc.*|xls.*|ppt.*|mp3|txt|rar|wma|mov|avi|wmv|flv|wav)$/i;
        var baseHref = '';
        if (jQuery('base').attr('href') != undefined) baseHref = jQuery('base').attr('href');
        var hrefRedirect = '';

        jQuery('#content-wrapper').on('click', 'a', function (event) {
            var el = jQuery(this);
            var track = true;
            var href = (typeof (el.attr('href')) != 'undefined') ? el.attr('href') : '';

            //Custom
            //href = href.split('?')[0];

            var isThisDomain = href.match(document.domain.split('.').reverse()[1] + '.' + document.domain.split('.').reverse()[0]);
            if (!href.match(/^javascript:/i)) {
                var elEv = []; elEv.value = 0, elEv.non_i = false;
                if (href.match(/^mailto\:/i)) {
                    elEv.category = 'MailTo';
                    elEv.action = 'Click';
                    elEv.label = href.replace(/^mailto\:/i, '');
                    elEv.loc = href;
                }
                else if (href.split('?')[0].match(filetypes) || el.hasClass("sfdownloadTitle") || el.hasClass("track")) {
                    //var extension = (/[.]/.exec(href)) ? /[^.]+$/.exec(href) : undefined;

                    elEv.category = 'File Download';
                    elEv.action = 'Click';
                    elEv.label = href.replace(/ /g, '-');
                    elEv.loc = baseHref + href;
                }
                else if (href.match(/^https?\:/i) && !isThisDomain) {
                    elEv.category = 'External Link';
                    elEv.action = 'Click';
                    elEv.label = href.replace(/^https?\:\/\//i, '');
                    elEv.non_i = true;
                    elEv.loc = href;
                }
                else if (href.match(/^tel\:/i)) {
                    elEv.category = 'Telephone';
                    elEv.action = 'Click';
                    elEv.label = href.replace(/^tel\:/i, '');
                    elEv.loc = href;
                }
                else track = false;

                if (track) {
                    var ret = true;

                    if ((elEv.category == 'External Link' || elEv.category == 'File Download') && (el.attr('target') == undefined || el.attr('target').toLowerCase() != '_blank')) {
                        sendGATagTrackingEvent(elEv.category, elEv.action, elEv.label, window.location.href);
                    }
                    else {
                        sendGATagTrackingEvent(elEv.category, elEv.action, elEv.label, window.location.href);
                    }

                    return ret;
                }
            }
        });
    }
}

function wireUpMiscGATracking() {
    //Navbar Icons
    $("#header-icons a").on("click", function () {
        sendGATagTrackingEvent("Toolbar", "Application", $(this).data("name"), window.location.href);
    });

    //Breadcrumb
    $(".breadcrumb-layout-wapper .sf-breadscrumb a").on("click", function () {
        sendGATagTrackingEvent("Breadcrumb", "Click", $(this).attr("href"));
    });

    //Sidenavs
    $(".medportal-nav a").on("click", function () {
        sendGATagTrackingEvent("Navigation Widget", "Click", $(this).text(), $(this).attr("href"));
    });
}


// FUNNY STUFF!
function callToCreature() {
    $("body").addClass("callto").addClass("creature");

    var creature = $("#creature").val();
    var mp3 = "";
    var image = "";
    var offsetAnimated = "0px";
    var offsetStart = "-700px";
    var delayTime = 1000;
    var onScreenTime = 3000;

    sendGATagTrackingEvent('Easter Egg', 'Creature', creature, window.location.href);

    switch (creature) {
        case "unicorn": {
            image = "/include/scripts/plugins/Raptorize-Kit/images/fartingunicorn.png";
            mp3 = "/include/scripts/plugins/Raptorize-Kit/audio/constant-fart.mp3";
            break;
        }
        case "mikael": {
            var mp3s = [
                "/include/scripts/plugins/Raptorize-Kit/audio/SwedishChef-RappersDelight.mp3",
                "/include/scripts/plugins/Raptorize-Kit/audio/SwedishChef-Phone.mp3"
            ];

            var selectedMp3 = mp3s[Math.floor(Math.random() * mp3s.length)];

            image = "/include/scripts/plugins/Raptorize-Kit/images/mikael.png";
            mp3 = selectedMp3,
            delayTime = 2000;
            offsetAnimated = "-130px";
            offsetStart = "-1000px";
            onScreenTime = 5000;
            break;
        }
    }

    if (image !== "") {
        $(document).raptorize({
            "enterOn": "timer",
            'delayTime': delayTime,
            'image': image,
            'mp3': mp3,
            'onScreenTime': onScreenTime,
            'offset': {
                "animated": offsetAnimated,
                "start": offsetStart
            }
        });
    }
}
// END THE LOLZ

//##########################################
//#region Helpers
function getMf() {
    var pathArray = window.location.pathname.split('/');

    for (var i = 0; i < pathArray.length; i++) {
        if (pathArray[i] === "mf") {
            //Okay next url part is the MF number
            var mfNumber = pathArray[i + 1]
            return Number(mfNumber)
        }
    }

    return null;
}

function getQuerystring(name) {
    name = name.replace(/(\[|\])/g, "\\$1");
    var regexS = "[\\?&]" + name + "=([^&#]*)";
    var regex = new RegExp(regexS);
    var results = regex.exec(window.location.search);
    var returnVal = "";

    if (results !== null) {
        returnVal = decodeURIComponent(results[1].replace(/\+/g, " "));
    }

    return returnVal;
}

function isOldIE() {
    if ($layout.isOldIE === null){
        var html = $('html');

        if (html.hasClass('ie7') || html.hasClass("ie8")) {
            $layout.isOldIE = true;
        } else {
            $layout.isOldIE = false;
        }
    }

    return $layout.isOldIE;
}

function printToPdf(element, filename, exportclasses, multipage) { 
    var papersize = "A4";
    //var papersize = "auto";
    //var r = confirm("Do you want the content to be split into pages? It's recommended to only say yes if you want to physically print the result.");
    //if (r == true) {
    //    papersize = "A4";
    //}

    if (typeof multipage == 'undefined') {
        multipage = true;
    }

    $("body").addClass("exporting");
    if (exportclasses) {
        $("body").addClass(exportclasses);
    }

    kendo.drawing.drawDOM(element, {
            paperSize: papersize
        })
        .then(function (group) {
            // Render the result as a PDF file
            return kendo.drawing.exportPDF(group, {
                paperSize: "auto",
                margin: { left: "0.3cm", top: "0.3cm", right: "0.3cm", bottom: "0.3cm" },
                multiPage: multipage
            });
        })
        .done(function (data) {
            // Save the PDF file
            kendo.saveAs({
                dataURI: data,
                fileName: filename + ".pdf",
                proxyURL: "/RestApi/utility/proxy/save"
            });

            $("body").removeClass("exporting");
            if (exportclasses)
                $("body").removeClass(exportclasses);
        });
}

function resetNotificationDots() {
    var keys = Object.keys(localStorage);
    for (var i = 0; i < keys.length; i++) {
        var key = keys[i];

        if (key.startsWith("dot-")) {
            localStorage.removeItem(key);
            console.log("Removed key " + key);
        }
    }

    lookForNotificationDots();
}

function wcfToDate(value) {
    var dateRegExp = /^\/Date\((.*?)\)\/$/;
    var date = dateRegExp.exec(value);

    return new Date(parseInt(date[1], 10));
}
//#endregion
//##########################################

//##########################################
//## TEMPLATES
//##########################################

function getRecentPagesTemplate() {
    return  "# for(var i = 0; i < data.length; i++) { #\
                <li class='page level-3'>\
                    <a class='' href='#= data[i].Url #' data-name='#= data[i].PageName #'>\
                        <span class='section #= data[i].Section #'></span>\
                        <span class='title'>\
                            #= data[i].PageName #\
                        </span>\
                        <div class='meta'>\
                            <span class='date margin-bottom-5'>#= data[i].Added #</span>\
                            <span class='url'>#= data[i].Url #</span>\
                        </div>\
                    </a>\
                </li>\
            # } #";
}
